export const PAGE_SOURCE = 'SourceTracking'

// AUTHENTICATION
export const LOGOUT_COMPLETED = 'LogoutCompleted'
export const AUTHENTICATION_VIEWED = 'Authentication Viewed'
export const AUTHENTICATION_STARTED = 'Authentication Started'
export const AUTHENTICATION_COMPLETED = 'Authentication Completed'
export const VERIFICATION_STARTED = 'VerificationStarted'
export const MAGIC_LINK_USED = 'Magic Link Used'
export const MAGIC_LINK_FAILED = 'Magic Link Failed'

// HOMEPAGE
export const BROWSE_EVENTS_CLICKED = 'Browse Events Clicked'
export const EXPLORE_FEED_ITEM_TAPPED = 'Explore Feed Item Tapped'
export const EXPLORE_FEED_SEE_ALL_CLICKED = 'Explore Feed See All Clicked'
export const EXPLORE_FEED_ITEM_VIEWED = 'Explore Feed Item Viewed'
export const EXPLORE_FEED_VIEWED = 'Explore Feed Viewed'
export const SMART_BANNER_VIEWED = 'Smart Banner Viewed'
export const SMART_BANNER_TAPPED = 'Smart Banner Tapped'
export const EXPLORE_NEARBY_EVENT_VIEWED = 'Explore Nearby Event Viewed'
export const EXPLORE_NEARBY_EVENT_TAPPED = 'Explore Nearby Event Tapped'
export const EXPLORE_NEARBY_LOCATION_VIEWED = 'Explore Nearby Location Viewed'
export const EXPLORE_NEARBY_LOCATION_TAPPED = 'Explore Nearby Location Tapped'
export const EXPLORE_CATEGORY_VIEWED = 'Explore Category Viewed'
export const EXPLORE_CATEGORY_TAPPED = 'Explore Category Tapped'

// SEARCH
export const SEARCH_STARTED = 'Search Started'
export const SEARCH_COMPLETED = 'Search Completed'
export const SEARCH_RESULT_CLICKED = 'Search Result Clicked'

// BROWSE
export const FILTER_OPENED = 'Filter Opened'
export const FILTER_OPTION_SELECTED = 'Filter Option Selected'
export const FILTER_CUSTOM_SELECTED = 'Filter Custom Selected'
export const EXPLORE_CONTENT_CLICKED = 'Explore Content Clicked'

// TERMS AND PRIVACY
export const TERMS_PRIVACY_CONSENT_ACCEPTED = 'TermsPrivacyConsentAccepted'
export const TERMS_PRIVACY_CONSENT_REJECTED = 'TermsPrivacyConsentRejected'
export const TERMS_PRIVACY_CONSENT_VIEWED = 'TermsPrivacyConsentViewed'

// LOCALE BAR
export const LOCALE_BAR_VIEWED = 'LocaleBarViewed'
export const LOCALE_BAR_DISMISSED = 'LocaleBarDismissed'
export const LOCALE_BAR_SET = 'LocaleBarSet'

// EVENT PAGES
export const EVENT_VIEWED = 'Event Viewed'
export const EVENT_INFO_VIEWED = 'Event Info Viewed'
export const EVENT_TYPE_VIEWED = 'Event Type Viewed'
export const LOCATION_URL_CLICKED = 'Location URL Clicked'
export const LISTING_VIEWED = 'ListingViewed'
export const LISTING_CLICKED = 'Listing Clicked'
export const LISTING_DATE_RANGE_FILTER_VIEWED = 'Listing Date Range Filter Viewed'
export const LISTING_DATE_RANGE_FILTER_SELECTED = 'Listing Date Range Filter Selected'
export const VIDEO_CLICKED = 'Video Clicked'
export const REPORT_EVENT_UPDATE_STARTED = 'Report Event Update Started'
export const REPORT_EVENT_UPDATE_COMPLETED = 'Report Event Update Completed'

// TICKET ALERTS
export const TICKET_ALERT_ENABLED = 'Ticket Alert Enabled'
export const TICKET_ALERT_DISABLED = 'Ticket Alert Disabled'
export const TICKET_ALERT_ENABLED_FROM_MAIL = 'Ticket Alert Enabled From Mail'
export const TICKET_ALERT_DISABLED_FROM_MAIL = 'Ticket Alert Disabled From Mail'
export const TICKET_ALERT_REMOVAL_FAILED = 'Ticket Alert Removal Failed'
export const TICKET_ALERT_DATE_RANGE_VIEWED = 'Ticket Alert Date Range Viewed'
export const TICKET_ALERT_DATE_RANGE_SELECTED = 'Ticket Alert Date Range Selected'

// PHONE VERIFICATION
export const PHONE_UPDATED = 'PhoneUpdated'
export const PHONE_SMS_SENT = 'PhoneSmsSent'
export const PHONE_SMS_RESEND = 'Phone Sms Resend'
export const PHONE_VERIFY_COMPLETED = 'PhoneVerifyCompleted'

// EMAIL VERIFICATION
export const EMAIL_VERIFICATION_STARTED = 'Email Verification Started'
export const EMAIL_VERIFICATION_NOT_RECEIVED = 'Email Not Received Clicked'
export const EMAIL_VERIFICATION_NOT_RECEIVED_OPTION = 'Email not Received Option Clicked'
export const EMAIL_VERIFICATION_COMPLETED = 'Email Verification Completed'

// ADD EVENT
export const ADD_EVENT_STARTED = 'Add Event Started'
export const ADD_EVENT_COMPLETED = 'Add Event Completed'
export const ADD_EVENT_FAILED = 'Add Event Failed'

// SELL FLOW
export const SELL_STARTED = 'Sell Started'
export const RESELL_CONTACT_CLICKED = 'ResellContactClicked'
export const RESELL_REJECTED = 'ResellRejected'
export const RESELL_STARTED = 'ResellStarted'
export const RESELL_COMPLETED = 'ResellCompleted'
export const RESELL_FOUND_VIA_SELL_FLOW = 'ResellFoundViaSellFlow'
export const ORIGINAL_PRICE_UPDATED = 'OriginalPriceUpdated'
export const SELLING_PRICE_SUGGESTIONS_SELECTED = 'SellingPriceSuggestionsSelected'
export const SELLLING_PRICE_UPDATE_FAILED = 'Selling Price Update Failed'
export const SUMMARY_ROW_CLICKED = 'SummaryRowClicked'
export const SUMMARY_CREATE_NEW_DRAFT = 'SummaryCreateNewDraft'
export const CHANGE_PAYOUT_INFORMATION_FAILED = 'Change Payout Information Failed'
export const CHANGE_PAYOUT_INFORMATION_UPDATED = 'Change Payout Information Updated'
export const PAYOUT_COUNTRY_SELECTED = 'Payout Country Selected'
export const FILE_UPLOAD_STARTED = 'File Upload Started'
export const FILE_UPLOAD_FAILED = 'File Upload Failed'
export const FILE_UPLOAD_COMPLETED = 'File Upload Completed'
export const FILE_REMOVED = 'FileRemoved'
export const FILE_CANCELED = 'File Canceled'
export const TICKET_NOT_UPDATED = 'TicketNotUpdated'
export const TICKET_UPDATED = 'TicketUpdated'
export const TICKET_INFO_SEATING_FORCED = 'TicketInfoSeatingForced'
export const TICKET_INFO_SKIP = 'TicketInfoSkip'
export const TICKET_INFO_ERROR_SHOWN = 'TicketInfoErrorShown'
export const DESCRIPTION_TOTAL_AVAILABLE_TICKETS = 'Description Total Available Tickets'
export const EVENT_DESELECTED = 'EventDeselected'
export const EVENT_TYPE_DESELECTED = 'EventTypeDeselected'
export const SHARED_ON_TWITTER = 'SharedOnTwitter'
export const SHARED_ON_FACEBOOK = 'SharedOnFacebook'
export const SHARED_ON_WHATSAPP = 'Shared On Whatsapp'
export const PUBLISH_STARTED = 'Publish Started'
export const PUBLISH_FAILED = 'Publish Failed'
export const PUBLISH_COMPLETED = 'Publish Completed'
export const KYC_PUBLISHED_HIDDEN = 'Listing Published Hidden'
export const PRE_PUBLISH_STARTED = 'Pre Publish Started'
export const PRE_PUBLISH_COMPLETED = 'Pre Publish Completed'

export const SELL_SUMMARY_VIEWED = 'Sell Summary Viewed'
export const SELL_AVATAR_VIEWED = 'Sell Avatar Viewed'
export const SELL_CREATE_EVENT_VIEWED = 'Sell Create Event Viewed'
export const SELL_EVENT_SELECTION_VIEWED = 'Sell Event Selection Viewed'
export const SELL_FILE_UPLOAD_VIEWED = 'Sell File Upload Viewed'
export const SELL_ORIGINAL_PRICE_VIEWED = 'Sell Original Price Viewed'
export const SELL_PAYOUT_CREDIT_CARD_VIEWED = 'Sell Payout Credit Card Viewed'
export const SELL_PAYOUT_VIEWED = 'Sell Payout Viewed'
export const SELL_PHONE_VIEWED = 'Sell Phone Viewed'
export const SELL_PUBLISH_VIEWED = 'Sell Publish Viewed'
export const SELL_PUBLISHED_VIEWED = 'Sell Published Viewed'
export const SELL_RESELL_VIEWED = 'Sell Resell Viewed'
export const SELL_RESELL_LOADING_VIEWED = 'Sell Resell Loading Viewed'
export const SELL_SELLING_PRICE_VIEWED = 'Sell Selling Price Viewed'
export const SELL_TICKET_DETAILS_VIEWED = 'Sell Ticket Details Viewed'
export const SELL_VERIFY_IDENTITY_VIEWED = 'Sell Verify Identity Viewed'
export const SELL_CONTINUE_CLICKED = 'Sell Continue Clicked'
export const SELL_SKIP_CLICKED = 'Sell Skip Clicked'

export const SELL_DRAFT_CREATED_STEP_COMPLETED = 'Sell Draft Created Step Completed'
export const SELL_EVENT_TYPE_SELECTION_STEP_COMPLETED = 'Sell Event Type Selection Step Completed'
export const SELL_FILE_UPLOAD_STEP_COMPLETED = 'Sell File Upload Step Completed'
export const SELL_ORIGINAL_PRICE_STEP_COMPLETED = 'Sell Original Price Step Completed'
export const SELL_SELLING_PRICE_STEP_COMPLETED = 'Sell Selling Price Step Completed'

// ACCOUNT - MY TICKETS
export const PERSONALISE_DIALOG_DISMISSED = 'PersonaliseDialogDismissed'
export const TICKET_DOWNLOAD_CLICKED = 'Ticket Download Clicked'
export const TICKET_PERSONALIZE_STARTED = 'Ticket Personalize Started'
export const TICKET_PERSONALIZE_COMPLETED = 'Ticket Personalize Completed'
export const TICKETS_VIEWED = 'Tickets Viewed'
export const TICKET_DETAILS_VIEWED = 'Ticket Details Viewed'
export const APP_DOWNLOAD_DIALOG_CLOSED = 'App Download Dialog Closed'
export const APP_DOWNLOAD_DIALOG_VIEWED = 'App Download Dialog Viewed'
export const TICKET_HELP_BUTTON_CLICKED = 'Ticket Help Button Clicked'
export const SHARE_LISTING_VIEWED = 'Share Listing Viewed'

// Ticket Sharing
export const SHARE_TICKET_CLICKED = 'Share Ticket Clicked'
export const ACCEPT_SHARED_TICKET_SCREEN_VIEWED = 'Accept Shared Ticket Screen Viewed'
export const ACCEPT_SHARED_TICKET_STARTED = 'Accept Shared Ticket Started'
export const ACCEPT_SHARED_TICKET_COMPLETED = 'Accept Shared Ticket Completed'
export const STOP_SHARING_STARTED = 'Stop Sharing Started'
export const STOP_SHARING_COMPLETED = 'Stop Sharing Completed'

// BUY FLOW
export const PRODUCT_ADDED = 'Product Added'
export const CART_VIEWED = 'Cart Viewed'
export const PRODUCT_REMOVED = 'Product Removed'

export const CHECKOUT_STARTED = 'Checkout Started'
export const CHECKOUT_DISCOUNT_CODE_APPLIED = 'Checkout Discount Code Applied'
export const CHECKOUT_DISCOUNT_CODE_REMOVED = 'Checkout Discount Code Removed'
export const CHECKOUT_PAYMENT_STARTED = 'Checkout Payment Started'
export const CHECKOUT_PAYMENT_FAILED = 'Checkout Payment Failed'
export const ORDER_COMPLETED = 'Order Completed'

export const CHECKOUT_PAYMENT_CC_ERROR = 'Checkout Payment CC Error'
export const CHECKOUT_EMAIL_CHANGE = 'Checkout Email Change'
export const CHECKOUT_COMPLETED = 'Checkout Completed'
export const CHECKOUT_PROCESSING_VIEWED = 'Checkout Processing Viewed'
export const CHECKOUT_PROCESSING_HIDDEN = 'Checkout Processing Hidden'

export const CHECKOUT_CONTINUE_CLICKED = 'Checkout Continue Clicked'
export const CHECKOUT_EMAIL_VIEWED = 'Checkout Email Viewed'
export const CHECKOUT_SUMMARY_VIEWED = 'Checkout Summary Viewed'
export const CHECKOUT_PHONE_VIEWED = 'Checkout Phone Viewed'
export const CHECKOUT_PAYMENT_METHOD_VIEWED = 'Checkout Payment Method Viewed'
export const CHECKOUT_COUNTRY_VIEWED = 'Checkout Country Viewed'

export const STRIPE_UNAVAILABLE = 'Stripe Unavailable'
export const STRIPE_FAILED = 'Stripe Failed'

// ORGANIZER TICKETS
export const CHECKOUT_PAY_BUTTON_CLICKED = 'Checkout Pay Button Clicked'
export const CHECKOUT_CONFIRMATION_VIEWED = 'Checkout Confirmation Viewed'
export const CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed'

// ACCOUNT - SOCIALS
export const SOCIAL_DISCONNECT_FACEBOOK = 'Social Disconnect Facebook'
export const SOCIAL_DISCONNECT_TWITTER = 'Social Disconnect Twitter'

// ACCOUNT - EMAIL
export const ACCOUNT_EXPORT_REQUESTED = 'Account Export Requested'

// TAGS
export const ARTIST_CLICKED = 'Artist Clicked'

// RECOMMENDATION
export const RECOMMENDATION_CLICKED = 'Recommendation Clicked'
export const RECOMMENDATION_VIEWED = 'Recommendation Viewed'

// ARTISTS
export const ADD_SOCIAL_MEDIA_COMPLETED = 'Add Social Media Completed'
export const ARTIST_FOLLOW_CLICKED = 'Artist Follow Clicked'
export const ARTIST_UNFOLLOW_CLICKED = 'Artist Unfollow Clicked'
export const ARTIST_SPOTIFY_CONNECT_SYNCED = 'Artist Spotify Connect Synced'
export const ARTIST_SPOTIFY_CONNECT_CLICKED = 'Artist Spotify Connect Clicked'
export const ARTIST_SPOTIFY_CONNECT_FAILED = 'Artist Spotify Connect Failed'
export const ARTIST_SPOTIFY_CONNECT_VIEWED = 'Artist Spotify Connect Viewed'
export const ARTIST_DESCRIPTION_SHOW_MORE_CLICKED = 'Artist Description Show More Clicked'

// NOTIFICATIONS
export const ARTIST_NOTIFICATIONS_ENABLED = 'Artist Notifications Enabled'
export const ARTIST_NOTIFICATIONS_DISABLED = 'Artist Notifications Disabled'
export const INBOX_NOTIFICATION_READ = 'Inbox Notification Read'

// CASES
export const START_CASE_ACCEPTED = 'Start case accepted'
export const CASE_ACTION_APPLIED = 'Case action applied'
export const CASE_STARTED_FROM_TICKET = 'Case Started From Ticket'
export const SEND_CASE_MESSAGE_FAILED = 'Send Case Message Failed'

// PARTNERS DASHBOARDS
export const PARTNER_DASHBOARD_CLICKED = 'Partner Dashboard Clicked'
export const PARTNER_EVENTS_LIST_VIEWED = 'Partner Events List Viewed'
export const PARTNER_EVENT_ADD_VIEWED = 'Partner Event Add Viewed'
export const PARTNER_EVENT_CREATE_VIEWED = 'Partner Event Create Viewed'
export const PARTNER_EXPORT_DATA_CLICKED = 'Partner Export Data Clicked'
export const PARTNER_EDIT_EVENT_VIEWED = 'Partner Edit Event Viewed'
export const EVENT_SELECTED = 'Event Selected'
export const CHANGE_HEADER_IMAGE_STARTED = 'Change Header Image Started'
export const CHANGE_HEADER_IMAGE_SELECTED = 'Change Header Image Selected'
export const CHANGE_HEADER_IMAGE_COMPLETED = 'Change Header Image Completed'
export const RANDOM_IMAGE_SELECTED = 'Random Image Selected'
export const EVENT_DESCRIPTION_UPDATED = 'Event Description Updated'
export const EVENT_VIDEO_URL_UPDATED = 'Event Video Url Updated'
export const PARTNER_TICKET_SHOP_ADDED = 'Partner Ticket Shop Added'
export const PARTNER_TICKET_SHOP_UPDATED = 'Partner Ticket Shop Updated'

// CONSENT
export const ORGANIZER_MARKETING_CONSENT_DISPLAYED = 'Organizer Marketing Consent Displayed'
export const ORGANIZER_MARKETING_CONSENT_GIVEN = 'Organizer Marketing Consent Given'
export const UPDATES_CONSENT_GIVEN = 'Updates Consent Given'

// ACCOUNT - VERIFY IDENTITY
export const VERIFY_IDENTITY_STARTED = 'Verify Identity Started'
export const VERIFY_IDENTITY_COMPLETED = 'Verify Identity Completed'
export const VERIFY_IDENTITY_FAILED = 'Verify Identity Failed'
export const IDENTITY_DOCUMENT_STARTED = 'Identity Document Started'
export const IDENTITY_DOCUMENT_STRIPE_VIEWED = 'Identity Document Stripe Viewed'
export const IDENTITY_DOCUMENT_STRIPE_STARTED = 'Identity Document Stripe Started'
export const IDENTITY_DOCUMENT_STRIPE_CANCELLED = 'Identity Document Stripe Cancelled'
export const IDENTITY_DOCUMENT_STRIPE_FAILED = 'Identity Document Stripe Failed'
export const IDENTITY_DOCUMENT_STRIPE_COMPLETED = 'Identity Document Stripe Completed'
export const IDENTITY_DOCUMENT_COMPLETED = 'Identity Document Completed'
export const IDENTITY_DOCUMENT_FAILED = 'Identity Document Failed'

// ORGANIZERS PAGES
export const ORGANIZER_PAGE_VIEWED = 'Organizer Page Viewed'
export const ORGANIZER_FOLLOWED = 'Organizer Followed'
export const ORGANIZER_UNFOLLOWED = 'Organizer Unfollowed'

// BETA FEATURES
export const BETA_FEATURE_ENABLED = 'Beta Feature Enabled'
export const BETA_FEATURE_DISABLED = 'Beta Feature Disabled'

// PARTNERS PAGE
export const PARTNER_PAGE_FORM_VIEWED = 'Partner Page Form Viewed'
export const PARTNER_PAGE_FORM_SUBMITTED = 'Partner Page Form Submitted'

// PREFERRED CITY
export const PREFERRED_CITY_BANNER_VIEWED = 'Preferred City Banner Viewed'
export const PREFERRED_CITY_BANNER_DISMISSED = 'Preferred City Banner Dismissed'
export const PREFERRED_CITY_BANNER_DIALOG_OPENED = 'Preferred City Banner Dialog Opened'
export const PREFERRED_CITY_ADDED = 'Preferred City Added'

// MISC
export const COPIED_SHARE_LINK = 'CopiedShareLink'
export const HELP_REACHED = 'Help Reached'
export const EVENT_REVIEW_SUBMITTED = 'Event Review Submitted'
export const APP_DOWNLOAD_CLICKED = 'App Download Clicked'
export const UNSUBSCRIBE_COMPLETED = 'Unsubscribe Completed'
export const UNSUBSCRIBE_FEEDBACK_GIVEN = 'Unsubscribe Feedback Given'
export const STAR_PAGE_OPENED = 'Star Page Opened'
export const TRUSTPILOT_PAGE_OPENED = 'Trustpilot Page Opened'
export const TRUSTPILOT_SCORE_CLICKED = 'Trustpilot Score Clicked'
export const AVATAR_UPLOAD_COMPLETED = 'Avatar Upload Completed'
export const CAMPAIGN_LEAD_SUBMITTED = 'Campaign Lead Submitted'
export const MISSING_NAME_FROM_PROVIDER = 'Missing Name From Provider'
export const CHECKOUT_UPSELLING_DIALOG_VIEWED = 'Checkout Upselling Dialog Viewed'
export const CHECKOUT_UPSELLING_VIEWED = 'Checkout Upselling Viewed'
export const EVENT_REMOVED_FROM_FAVORITES = 'Event Removed From Favorites'
export const EVENT_ADDED_TO_FAVORITES = 'Event Added To Favorites'

// VERIFICATION FLOW
export const VERIFICATION_FLOW_STARTED = 'Verification Flow Started'
export const VERIFICATION_FLOW_DISMISSED = 'Verification Flow Dismissed'
export const VERIFICATION_FLOW_COMPLETED = 'Verification Flow Completed'
export const VERIFICATION_FLOW_EXITED = 'Verification Flow Exited'
export const VERIFICATION_FLOW_PHONE_VIEWED = 'Verification Flow Phone Viewed'
export const VERIFICATION_FLOW_AVATAR_VIEWED = 'Verification Flow Avatar Viewed'
export const VERIFICATION_FLOW_AVATAR_SKIPPED = 'Verification Flow Avatar Skipped'
